<template>
  <b-overlay
    :show="loader.pagina"
    opacity="0.50"
    rounded="sm"
  >
    <div>
      <section>

        <!-- content -->
        <b-row class="match-height">
          <!-- list dinamic -->
          <b-col
            v-for="item in kbalumnos"
            :id="'option-'+item.id"
            :key="item.id"
            md="3"
            sm="6"
            class="kb-search-content"
          >
            <b-card
              :class="item.cls"
              :img-src="require('@/assets/images/illustration/' + item.img)"
              :img-alt="item.img.slice(5)"
              img-top
              @click="$router.push({ name: item.goahead })"
            >
              <h4>{{ item.title }}</h4>
              <b-card-text class="mt-1">
                {{ item.desc }}
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </section>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, VBModal, BOverlay,
} from 'bootstrap-vue'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { getData } from '@core/utils/http/general'
import { HelpVTour } from '../components/ayuda/useAyudaTour'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BOverlay,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      loader: {
        pagina: false,
      },
      kbalumnos: [],
      knowledgeBaseSearchQuery: '',
      HelpVTour,
    }
  },
  mounted() {
    this.get_data()
  },
  methods: {
    get_data() {
      this.loader.pagina = true
      getData({ action: 10, token: store.state.cuenta.session.token }, 'wsadminpagecampus')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) this.kbalumnos = response.data.data
          else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Sección en construcción`,
              variant: 'danger',
              solid: true,
            })
          }
          this.loader.pagina = false
        }).catch(err => {
          this.loader.pagina = false
          this.$bvToast.toast(err, {
            title: 'Error, No hay conexión',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>
<style scoped>
.importanteItem {
  border: 1px solid #7367f0;
}
